// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"dfd5f8ca","475":"0bf2fce7","764":"de471d8f"}[chunkId] + ".chunk.js";
};